import api from '../api/axiosInstance';

// Obtener todas las entradas
export const getEntradaService = async () => {
    try {
        const response = await api.get('/personal/datos-entrada');
        return response.data; // debe ser un array
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error desconocido al recuperar información' };
    }
};
export const getTiposPagoService = async () => {
    try {
        const response = await api.get('/propietario/tipos-pago'); // endpoint que devuelve lista de tipos de pago
        return response.data; // se espera un array de strings o objetos {id, nombre}
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al cargar tipos de pago' };
    }
};
// Crear una nueva entrada
export const crearEntradaService = async ({ nombreEntrada, tipoPago, precio, duracion, cantidadEntradas }) => {
    try {
        const body = {
            nombreEntrada,
            tipoPago,
            precio,
            duracion,
            cantidadEntradas
        };
        const response = await api.post('/propietario/crear-entrada', body);
        return response.data; // la entrada creada
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al crear entrada' };
    }
};

// Actualizar entrada existente
export const updateEntradaService = async ({ id, nombreEntrada, tipoPago, precio, duracion, cantidadEntradas }) => {
    try {
        const body = {
            id,
            nombreEntrada,
            tipoPago,
            precio,
            duracion,
            cantidadEntradas
        };
        const response = await api.post('/propietario/actualizar-entrada', body);
        return response.data; // mensaje de éxito del backend
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al actualizar entrada' };
    }
};
export const eliminarEntradaService = async (entradaId) => {
    try {
        const response = await api.post('/propietario/eliminar-entrada', null, {
            params: { entradaId }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al eliminar entrada' };
    }
};

// Obtener la única media
export const getMediasService = async () => {
    try {
        const response = await api.get('/medias');
        return response.data; // objeto media
    } catch (error) {
        throw error.response?.data || { mensaje: 'No existe información de medias' };
    }
};

// Crear o actualizar media
export const updateMediasService = async ({ id, precioUnitario }) => {
    try {
        const response = await api.post('/propietario/medias', { id, precio: precioUnitario });
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error al guardar medias' };
    }
};

